import { render, staticRenderFns } from "./VueTab.vue?vue&type=template&id=490573c2&"
import script from "./VueTab.vue?vue&type=script&lang=js&"
export * from "./VueTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports